import React from 'react';
import Input from 'components/input/input.component';
import { IKpu } from 'interfaces/applicant.interface';

interface IProps {
  kpu: IKpu;
  handleChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
}

const IpConnection: React.FC<IProps> = ({ kpu, handleChange }) => {
  return (
    <>
      <Input name="ip" value={kpu.ip || ''} label={'IP'} onChange={handleChange} />
      <Input name="port" value={kpu.port || ''} label={'Port'} onChange={handleChange} />
      <Input
        name="rSMDBConnectionString"
        value={kpu.rSMDBConnectionString || ''}
        label={'SMDB Connection'}
        onChange={handleChange}
      />
      <Input name="dComUid" value={kpu.dComUid || ''} label={'Com Uid'} onChange={handleChange} />
      <Input name="dComPwd" value={kpu.dComPwd || ''} label={'Com Pwd'} onChange={handleChange} />
    </>
  );
};

export default IpConnection;
